jQuery(document).ready(function () {

    // Add containers to elements
    jQuery('header .menu .main-menu-toggle > a').wrap('<div>');
    jQuery('.main-menu .main-menu-content a').wrap('<div>');


    $('.main-menu .sub-menu > .menu-item a').on('mouseenter touchstart', function () {
        var image = $(this).parent().parent().attr('data-image');

        if (image) {

            $('.main-menu .right-image').attr('src', image)

        }
    });


    // Toggle main menu
    jQuery('header .menu .main-menu-toggle').click(function (e) {
        e.preventDefault();
        // Remove highlight on active element
        jQuery('header .main-menu-toggle > ul > li > div > a').removeClass('active');
        // Hide opened elements
        jQuery('header .main-menu-toggle > ul > li > .sub-menu').hide();
        // Toogle menu
        jQuery('header').toggleClass('main-menu-toggled');
    });

    // Toggle menu element
    jQuery('header .main-menu-toggle > ul > li > div > a').click(function (e) {
        e.preventDefault();
        var thisElem = jQuery(this);
        // Highlight active element
        jQuery('header .main-menu-toggle > ul > li > div > a').removeClass('active');
        thisElem.toggleClass('active');
        // Hide opened elements
        jQuery('header .main-menu-toggle > ul > li > .sub-menu').hide();
        // If element have children -> show children
        if (thisElem.parent().parent().hasClass('menu-item-has-children')) {
            thisElem.parent().parent().find('.sub-menu').first().toggle();
        }
        // If element does not have children -> go to url
        else {
            window.location.href = thisElem.attr('href');
        }
    });

    // CircleType
    jQuery("header .main-menu-badge .image-border-text").each(function () {
        var circleType = new CircleType(jQuery(this)[0]);
        circleType.radius(330);
        // Border text offset
        if (jQuery(this).data('image-border-text-offset')) {
            jQuery(this).css({'transform': 'rotate(' + jQuery(this).data('image-border-text-offset') + 'deg)'});
        }
        // Add class for responsive
        jQuery(jQuery(this)[0]).parents('.main-menu-badge').addClass('scaled');
    });

    // Show search window
    jQuery('header .header .menu ul li.search').click(function (e) {
        e.preventDefault();
        jQuery('header .search-overlay').css({'display': 'flex'});
        jQuery('header .search-overlay .search-formInput').val('').focus();
    });

    // Hide search window
    jQuery('.search-overlay .search-close').click(function () {
        jQuery('header .search-overlay').css({'display': 'none'});
    });

    // Header slider
    if (jQuery('.header-slider').length) {
        var headerSlider = tns({
            container: '.header-slider',
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayButtonOutput: false,
            mouseDrag: true,
            controls: false,
            nav: false,
            loop: true,
            autoHeight: true
        });
    }

});

jQuery(window).resize(function () {

    // Change positions
    if (window.matchMedia("(min-width: 1023px)").matches) {
        jQuery('header .header .menu').on('mouseenter', 'li.lock', function () {
            jQuery('header').addClass('lock-menu-toggled');
        });
        jQuery('header .header .menu').on('mouseleave', 'li.lock', function () {
            jQuery('header').removeClass('lock-menu-toggled');
        });
    } else {
        jQuery('header .header .menu').on('click', 'li.lock', function () {
            jQuery('header').toggleClass('lock-menu-toggled');
        });
    }

});

//Prevent Default Event on links where the href is simply a hashtag
jQuery(document).on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
})